<template>
  	<ResellerConnectedUser />
</template>

<script>

// @ is an alias to /src
import ResellerConnectedUser from "@/components/Client/ConnectedPIN/ResellerConnectedUser.vue";

export default {
  name: "ResellerConnectedUsers",
  components: {
    ResellerConnectedUser,
  },
};
</script>
